import { Injectable } from '@angular/core';
import {
  ParkingSite,
  ParkingSitePayload,
  ParkingSiteTableDto,
} from '../../models/parking/parking-site.model';

@Injectable({
  providedIn: 'root',
})
export class MapperParkingSiteService {
  createEmpty(): ParkingSite {
    return {
      id: 0,
      name: '',
      key: '',
      taxId: '',
      address: '',
      latitude: null,
      longitude: null,
      open: true,
      isOnline: false,
      hasLogo: false,
      logoBase64: '',
      openTime: '',
      closeTime: '',
      siteEv: '',
      monthly: false,
      ev: false,
      parking: true,
      taiwanUrl: '',
      siteParking: '',
      taiwanSite: false,
      createUid: null,
      writeUid: null,
      createDate: null,
      writeDate: null,
    };
  }

  mapFromDto(dto: ParkingSiteTableDto): ParkingSite {
    return {
      id: dto.id,
      name: dto.name ?? '',
      key: dto.key ?? '',
      taxId: dto.taxId ?? '',
      address: dto.address ?? '',
      latitude: dto.latitude ?? null,
      longitude: dto.longitude ?? null,
      open: dto.open ?? false,
      isOnline: dto.isOnline ?? false,
      hasLogo: dto.hasLogo ?? !!(dto.logoBase64 && dto.logoBase64.length > 0),
      logoBase64: dto.logoBase64 ?? '',
      openTime: dto.openTime ?? '',
      closeTime: dto.closeTime ?? '',
      siteEv: dto.siteEv ?? '',
      monthly: dto.monthly ?? false,
      ev: dto.ev ?? false,
      parking: dto.parking ?? false,
      taiwanUrl: dto.taiwanUrl ?? '',
      siteParking: dto.siteParking ?? '',
      taiwanSite: dto.taiwanSite ?? false,
      createUid: dto.createUid ?? null,
      writeUid: dto.writeUid ?? null,
      createDate: dto.createDate ? new Date(dto.createDate) : null,
      writeDate: dto.writeDate ? new Date(dto.writeDate) : null,
    };
  }

  mapToPayload(site: ParkingSite, userId: number, menuId: number): ParkingSitePayload {
    return {
      name: site.name.trim(),
      key: site.key?.trim() || undefined,
      taxId: site.taxId?.trim() || undefined,
      address: site.address?.trim() || undefined,
      latitude: site.latitude,
      longitude: site.longitude,
      open: site.open,
      isOnline: site.isOnline,
      logoBase64: site.logoBase64?.trim() || null,
      openTime: site.openTime?.trim() || undefined,
      closeTime: site.closeTime?.trim() || undefined,
      siteEv: site.siteEv?.trim() || undefined,
      monthly: site.monthly,
      ev: site.ev,
      parking: site.parking,
      taiwanUrl: site.taiwanUrl?.trim() || undefined,
      siteParking: site.siteParking?.trim() || undefined,
      taiwanSite: site.taiwanSite,
      userId,
      menuId,
    };
  }

  mapSearchField(field: string): string {
    return field;
  }

  mapSortColumn(column: string): string {
    return column.toLowerCase();
  }

  /** Normalize data URL / raw base64 for <img src> */
  toLogoSrc(logoBase64: string | null | undefined): string | null {
    if (!logoBase64?.trim()) return null;
    const value = logoBase64.trim();
    if (value.startsWith('data:')) return value;
    return `data:image/png;base64,${value}`;
  }
}
